module.exports = __webpack_public_path__ + "static/media/TopDelivery2_1.a90ab270.jpg";